angular.module('impactx.basket').directive('ixBasketTemplateMenuList', [function() {
    return {
        scope: {
            menuitem: "=",
            options: "="
        },
        controller: 'BasketTemplateMenuListCtrl',
        controllerAs: 'basketTemplateMenuListCtrl',
        restrict: 'E',
        templateUrl: 'modules/basket/templates/baskettemplatesubmenu.tmpl.html'
    }
}]);